export const GET_EMPLOYMENT_RELATIONSHIP = 'GET_EMPLOYMENT_RELATIONSHIP';
export const LOADING_EMPLOYMENT_RELATIONSHIP = 'LOADING_EMPLOYMENT_RELATIONSHIP';